import en from '@/i18n/lang/en/en'
import Layout from '@/views/layout/layout'


let routeName = en.routeName
export default [
    {
      path: '/message',
      component: () => import('@/views/message-center/index.vue'),
      name: 'message',
      hiddenFlag: 'Y',
      meta: {
        title: '消息中心'  // 添加页面标题
      },
      children: []
    },
    {
      path: '/email',
      component: () => import('@/views/email-center/index.vue'),
      name: 'email',
      hiddenFlag: 'Y',
      meta: {
        title: '邮箱中心'  // 添加页面标题
      },
      children: []
    },
]



// WEBPACK FOOTER //
// ./src/router/modules/ims/message.js